import React from "react";
import { useSetting, useSettingsActions } from "./SettingsStore.tsx";
import { SelectButton } from "primereact/selectbutton";
import { BoxPlotQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The box-plot dial (ADR 0099 §5): what to ask.
 *
 * Basic tier, as the format's own panel is (ADR 0023 §2, as ADR 0079 applied
 * it): there is nothing else to set. The operator bar is hidden for this
 * format. Reads its own slice of the settings (ADR 0081), so a change
 * elsewhere on the panel does not redraw it.
 */
export const BoxPlotSettings = React.memo(function BoxPlotSettings() {
    const { getSettings, setSettings } = useSettingsActions();
    const { question, language } = useSetting((settings) => ({
        question: settings.BoxPlotQuestion,
        language: settings.Language,
    }));
    const t = useTranslation();

    function handleQuestionChange(value: BoxPlotQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...getSettings(), BoxPlotQuestion: value });
    }

    return (
        <div className="boxPlotSettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={question}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(BoxPlotQuestionOptions), language)}
                    className="select regrouping"
                    aria-label={t('settings.questionType')}
                />
            </div>
        </div>
    );
});

export default BoxPlotSettings;
